import type { TranscriptEntry } from '@highlight/common'

export interface CreateTranscriptEntryParams {
  speaker: string
  text: string
  absoluteTimestamp: string
  relativeTimestampMs: number
  isHost: boolean
  participantId?: number
  dgSpeakerIndex?: string
  micEpoch?: number
}

export function createTranscriptEntry(params: CreateTranscriptEntryParams): TranscriptEntry {
  return {
    speaker: params.speaker,
    text: params.text,
    timestamp: {
      absolute: params.absoluteTimestamp,
      relative: params.relativeTimestampMs,
    },
    isHost: params.isHost,
    ...(params.participantId != null && { participantId: params.participantId }),
    ...(params.dgSpeakerIndex != null && { dgSpeakerIndex: params.dgSpeakerIndex }),
    ...(params.micEpoch != null && { micEpoch: params.micEpoch }),
  }
}
